import { ReactNode } from "react";
import { useNavigate, useLocation, Outlet, Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useState, useEffect } from "react";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarProvider,
  SidebarInset
} from "@/components/ui/sidebar";
import { useAuth } from "@/contexts/auth";
import { MobileHeader } from "@/components/layout/MobileHeader";
import { SidebarUserSection } from "@/components/layout/SidebarUserSection";
import { SidebarMenuItems } from "@/components/layout/SidebarMenuItems";


const MainLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, isAdmin, isLoading, userProfile } = useAuth();
  
  // Set theme based on user preference or localStorage
  useEffect(() => {
    if (userProfile?.theme_preference) {
      const userTheme = userProfile.theme_preference;
      document.documentElement.classList.toggle('dark', userTheme === 'dark');
      localStorage.setItem('theme', userTheme);
      return;
    }
    
    const savedTheme = localStorage.getItem('theme') || 'dark';
    document.documentElement.classList.toggle('dark', savedTheme === 'dark');
  }, [userProfile]);
  
  if (!isLoading && !isAuthenticated) {
    return <Navigate to="/auth/login" />;
  }

  if (isLoading) {
    return <div className="flex items-center justify-center h-screen">
      <Loader2 className="h-8 w-8 animate-spin text-accent" />
    </div>;
  }
  
  
  const isMarketplaceRoute = location.pathname.startsWith('/marketplace');

  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full bg-background">
        <Sidebar className="hidden md:block border-r border-sidebar-border/30 shadow-sidebar" collapsible="icon">
          <SidebarHeader>
            <SidebarUserSection />
          </SidebarHeader>
          
          <SidebarContent className="px-2 py-4 neo-scrollbar">
            <SidebarGroup>
              <SidebarGroupContent>
                <SidebarMenuItems isAdmin={isAdmin} />
              </SidebarGroupContent>
            </SidebarGroup>
          </SidebarContent>
          
          
        </Sidebar>

        <SidebarInset className="flex-1 flex flex-col min-w-0">
          <MobileHeader />
          <main className="flex-1 min-w-0 animate-fade-in">
            <Outlet />
          </main>
        </SidebarInset>
      </div>
    </SidebarProvider>
  );
};

export default MainLayout;
